(function () {
  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(
        cents,
        window.themeVariables?.settings?.moneyFormat || window.Shopify.money_format || '{{amount}}'
      );
    }

    return (cents / 100).toFixed(2);
  }

  function parseCatalog(section, blockId) {
    var script = section.querySelector('[data-bundle-catalog="' + blockId + '"]');

    if (!script) {
      return [];
    }

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return [];
    }
  }

  function getAvailableVariants(product) {
    return (product.variants || []).filter(function (variant) {
      return variant.available !== false;
    });
  }

  function isDefaultTitleOption(optionName, values) {
    if (values.length !== 1) {
      return false;
    }

    var normalizedName = String(optionName || '').toLowerCase();
    var normalizedValue = String(values[0] || '').toLowerCase();

    return normalizedName === 'title' && normalizedValue === 'default title';
  }

  function findVariant(variants, selectedByIndex) {
    if (!variants.length) {
      return null;
    }

    var selectedIndexes = Object.keys(selectedByIndex || {});

    if (!selectedIndexes.length) {
      return variants[0];
    }

    return (
      variants.find(function (variant) {
        return selectedIndexes.every(function (index) {
          return variant.options[Number(index)] === selectedByIndex[index];
        });
      }) || null
    );
  }

  function applyVariantToOptionSelects(row, variant) {
    if (!row || !variant) {
      return;
    }

    row.querySelectorAll('[data-bundle-option]').forEach(function (select) {
      var index = parseInt(select.dataset.optionIndex, 10);

      if (!Number.isNaN(index) && variant.options[index] !== undefined) {
        select.value = variant.options[index];
      }
    });
  }

  function resolveVariant(product, row) {
    var variants = getAvailableVariants(product);

    if (!variants.length) {
      return null;
    }

    var selectedVariant = findVariant(variants, getSelectedOptionsByIndex(row));

    if (selectedVariant) {
      return selectedVariant;
    }

    selectedVariant = variants[0];
    applyVariantToOptionSelects(row, selectedVariant);
    return selectedVariant;
  }

  function getSelectedOptionsByIndex(row) {
    var selectedByIndex = {};

    if (!row) {
      return selectedByIndex;
    }

    row.querySelectorAll('[data-bundle-option]').forEach(function (select) {
      var index = parseInt(select.dataset.optionIndex, 10);

      if (!Number.isNaN(index)) {
        selectedByIndex[index] = select.value;
      }
    });

    return selectedByIndex;
  }

  function findVariantById(product, variantId) {
    return (product?.variants || []).find(function (variant) {
      return String(variant.id) === String(variantId);
    });
  }

  function buildOptionSelects(product, selectedVariant) {
    if (!product.options || !product.options.length) {
      return '';
    }

    var html = '';
    var availableVariants = getAvailableVariants(product);

    product.options.forEach(function (optionName, optionIndex) {
      var values = [];
      availableVariants.forEach(function (variant) {
        var value = variant.options[optionIndex];
        if (value && values.indexOf(value) === -1) {
          values.push(value);
        }
      });

      if (!values.length || isDefaultTitleOption(optionName, values)) {
        return;
      }

      html +=
        '<select class="et-bundle-hero__select et-bundle-hero__select--option" data-bundle-option data-option-index="' +
        optionIndex +
        '" aria-label="' +
        optionName.replace(/"/g, '&quot;') +
        '">';

      values.forEach(function (value) {
        var selected =
          selectedVariant && selectedVariant.options[optionIndex] === value ? ' selected' : '';
        html +=
          '<option value="' +
          String(value).replace(/"/g, '&quot;') +
          '"' +
          selected +
          '>' +
          value +
          '</option>';
      });

      html += '</select>';
    });

    return html;
  }

  function getHeroRoot(section) {
    return section.querySelector('.et-bundle-hero') || section;
  }

  function initOfferTimer(section) {
    section.querySelectorAll('[data-offer-timer]').forEach(function (timer) {
      initSingleOfferTimer(timer);
    });
  }

  function initSingleOfferTimer(timer) {
    var textEl = timer.querySelector('[data-offer-timer-text]');

    if (!textEl) {
      return;
    }

    function pad(value) {
      return value < 10 ? '0' + value : String(value);
    }

    function getTargetDate() {
      var now = new Date();
      var mode = timer.dataset.timerMode;
      var timerText = timer.dataset.timerText;

      switch (mode) {
        case 'week': {
          var daysUntilNextMonday = (8 - now.getDay()) % 7;
          if (daysUntilNextMonday === 0) {
            daysUntilNextMonday = 7;
          }
          var targetDate = new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate() + daysUntilNextMonday
          );
          targetDate.setHours(0, 0, 0, 0);
          return targetDate;
        }
        case 'month':
          return new Date(now.getFullYear(), now.getMonth() + 1, 1);
        case 'date': {
          var parsed = new Date(timerText);
          if (!Number.isNaN(parsed.getTime()) && parsed > now) {
            return parsed;
          }
          return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
        }
        default:
          return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      }
    }

    function update() {
      var diff = getTargetDate() - new Date();

      if (diff <= 0) {
        textEl.textContent = timer.dataset.offerPrefix + ' 00h 00m 00s';
        return;
      }

      var hours = Math.floor(diff / (1000 * 60 * 60));
      var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((diff % (1000 * 60)) / 1000);

      textEl.textContent =
        timer.dataset.offerPrefix +
        ' ' +
        pad(hours) +
        'h ' +
        pad(minutes) +
        'm ' +
        pad(seconds) +
        's';
    }

    update();
    window.setInterval(update, 1000);
  }

  function whenSwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }

    window.addEventListener('load', callback, { once: true });
  }

  function parseDiscountTiers(heroRoot) {
    try {
      return JSON.parse(heroRoot.dataset.bundleDiscountTiers || '{}');
    } catch (error) {
      return {};
    }
  }

  function getBundleDiscountPercent(productCount, tiers) {
    var count = Math.max(0, parseInt(productCount, 10) || 0);

    if (!count) {
      return 0;
    }

    if (tiers[String(count)] !== undefined) {
      return parseFloat(tiers[String(count)]) || 0;
    }

    if (count >= 4 && tiers['4'] !== undefined) {
      return parseFloat(tiers['4']) || 0;
    }

    return 0;
  }

  function initHero(section) {
    if (section.dataset.initialized === 'true') {
      return;
    }

    section.dataset.initialized = 'true';

    var heroRoot = getHeroRoot(section);
    var state = {
      items: {},
      editingBlockId: null,
      activeBlockId: section.querySelector('.et-bundle-hero__tab.is-active')?.dataset.blockId || null
    };

    var buyButton = section.querySelector('[data-bundle-buy]');
    var discountTiers = parseDiscountTiers(heroRoot);
    var totalRows = section.querySelectorAll('[data-bundle-total]');
    var previewSliderEl = section.querySelector('[data-bundle-preview-slider]');
    var previewSlidesEl = section.querySelector('[data-bundle-preview-slides]');
    var previewSwiper = null;
    var defaultImageSrc =
      section.querySelector('[data-bundle-main-image]')?.dataset.defaultSrc ||
      section.querySelector('[data-bundle-product-thumb]')?.dataset.placeholder ||
      '';

    function getRow(blockId) {
      return section.querySelector('[data-category-row="' + blockId + '"]');
    }

    function getSelectedProduct(blockId) {
      var row = getRow(blockId);
      var select = row?.querySelector('[data-bundle-product-select]');
      var catalog = parseCatalog(section, blockId);

      if (!select || !select.value) {
        return null;
      }

      return catalog.find(function (product) {
        return String(product.id) === String(select.value);
      });
    }

    function getSelectedVariant(blockId) {
      var row = getRow(blockId);
      var product = getSelectedProduct(blockId);

      if (!row || !product) {
        return null;
      }

      return resolveVariant(product, row);
    }

    function renderProductRow(blockId, preserveSelection) {
      var row = getRow(blockId);
      var product = getSelectedProduct(blockId);
      var thumb = row?.querySelector('[data-bundle-product-thumb]');
      var optionsWrap = row?.querySelector('[data-bundle-variant-options]');

      if (!row || !product || !optionsWrap) {
        return;
      }

      var variants = getAvailableVariants(product);
      var selectedVariant = preserveSelection ? resolveVariant(product, row) : null;
      var defaultVariant = selectedVariant || variants[0] || null;

      optionsWrap.innerHTML = buildOptionSelects(product, defaultVariant);
      applyVariantToOptionSelects(row, defaultVariant);

      var variant = resolveVariant(product, row);

      if (thumb) {
        thumb.src = variant?.featured_image || product.featured_image || thumb.dataset.placeholder || '';
        thumb.alt = product.title;
      }
    }

    function updateProductThumb(blockId) {
      var row = getRow(blockId);
      var product = getSelectedProduct(blockId);
      var variant = product && row ? resolveVariant(product, row) : null;
      var thumb = row?.querySelector('[data-bundle-product-thumb]');

      if (thumb && product) {
        thumb.src = variant?.featured_image || product.featured_image || thumb.dataset.placeholder || '';
        thumb.alt = product.title;
      }
    }

    function updateQtyControls(blockId) {
      var row = getRow(blockId);

      if (!row) {
        return;
      }

      var qtyEl = row.querySelector('[data-bundle-qty-value]');
      var removeBtn = row.querySelector('[data-bundle-remove]');
      var minusBtn = row.querySelector('[data-bundle-qty-minus]');
      var qty = parseInt(qtyEl?.textContent || '1', 10) || 1;

      if (removeBtn) {
        removeBtn.hidden = qty > 1;
      }

      if (minusBtn) {
        minusBtn.hidden = qty <= 1;
      }
    }

    function showRowState(blockId, mode) {
      var row = getRow(blockId);

      if (!row) {
        return;
      }

      var placeholder = row.querySelector('[data-bundle-add-placeholder]');
      var productRow = row.querySelector('[data-bundle-product-row]');

      if (placeholder) {
        placeholder.hidden = mode !== 'empty';
      }

      if (productRow) {
        productRow.hidden = mode === 'empty';
      }
    }

    function restoreRowFromState(blockId) {
      var item = state.items[blockId];
      var row = getRow(blockId);

      if (!item || !row) {
        return;
      }

      showRowState(blockId, 'filled');

      var select = row.querySelector('[data-bundle-product-select]');
      var qtyEl = row.querySelector('[data-bundle-qty-value]');

      if (select && item.productId) {
        select.value = String(item.productId);
      }

      if (qtyEl) {
        qtyEl.textContent = String(item.quantity || 1);
      }

      updateQtyControls(blockId);

      renderProductRow(blockId);

      var product = getSelectedProduct(blockId);
      var variant = product ? findVariantById(product, item.variantId) : null;

      if (product && variant) {
        row.querySelectorAll('[data-bundle-option]').forEach(function (optionSelect, index) {
          if (variant.options[index] !== undefined) {
            optionSelect.value = variant.options[index];
          }
        });
        renderProductRow(blockId);
      }

      var thumb = row.querySelector('[data-bundle-product-thumb]');
      if (thumb && item.image) {
        thumb.src = item.image;
        thumb.alt = item.title || '';
      }
    }

    function refreshRowStates() {
      section.querySelectorAll('[data-category-row]').forEach(function (row) {
        var blockId = row.dataset.categoryRow;

        if (state.items[blockId]) {
          restoreRowFromState(blockId);
          return;
        }

        if (state.editingBlockId === blockId) {
          showRowState(blockId, 'editing');
          return;
        }

        showRowState(blockId, 'empty');
      });
    }

    function destroyPreviewSwiper() {
      if (previewSwiper) {
        previewSwiper.destroy(true, true);
        previewSwiper = null;
      }

      if (previewSliderEl) {
        previewSliderEl.classList.remove('swiper-initialized', 'swiper-horizontal', 'swiper-backface-hidden');
        previewSliderEl.dataset.initialized = 'false';
      }
    }

    function initPreviewSwiper(activeIndex) {
      if (!previewSliderEl || typeof Swiper === 'undefined' || previewSwiper) {
        return;
      }

      previewSwiper = new Swiper(previewSliderEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: false,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        pagination: {
          el: previewSliderEl.querySelector('.et-bundle-hero__preview-pagination'),
          clickable: true
        }
      });

      previewSliderEl.dataset.initialized = 'true';

      if (typeof activeIndex === 'number') {
        previewSwiper.slideTo(activeIndex, 0);
      }
    }

    function renderPreviewSlider() {
      if (!previewSliderEl || !previewSlidesEl) {
        return;
      }

      var productSlides = [];

      section.querySelectorAll('[data-category-row]').forEach(function (row) {
        var blockId = row.dataset.categoryRow;
        var item = state.items[blockId];

        if (item?.image) {
          productSlides.push(item);
        }
      });

      var previousIndex = previewSwiper ? previewSwiper.activeIndex : 0;

      destroyPreviewSwiper();

      previewSlidesEl
        .querySelectorAll('.et-bundle-hero__preview-slide:not(.et-bundle-hero__preview-slide--default)')
        .forEach(function (slide) {
          slide.remove();
        });

      productSlides.forEach(function (item) {
        var slide = document.createElement('div');
        slide.className = 'swiper-slide et-bundle-hero__preview-slide';
        slide.innerHTML =
          '<img src="' +
          item.image +
          '" alt="' +
          (item.title || '').replace(/"/g, '&quot;') +
          '" width="560" height="560" loading="lazy">';
        previewSlidesEl.appendChild(slide);
      });

      var pagination = previewSliderEl.querySelector('.et-bundle-hero__preview-pagination');

      if (pagination) {
        pagination.hidden = productSlides.length === 0;
      }

      // Stay on the slide the visitor is looking at (the default image on load) —
      // adding a product extends the slider instead of jumping to its photo.
      var activeIndex = Math.min(previousIndex, productSlides.length);

      whenSwiperReady(function () {
        requestAnimationFrame(function () {
          initPreviewSwiper(activeIndex);
        });
      });
    }

    function renderSlots() {
      section.querySelectorAll('[data-category-row]').forEach(function (row) {
        var blockId = row.dataset.categoryRow;
        var slot = section.querySelector('[data-bundle-slot="' + blockId + '"]');
        var item = state.items[blockId];

        if (!slot) {
          return;
        }

        if (!item || !item.image) {
          slot.innerHTML = slot.dataset.emptyHtml || '';
          slot.classList.add('et-bundle-hero__slot--empty');
          return;
        }

        slot.classList.remove('et-bundle-hero__slot--empty');
        slot.innerHTML =
          '<img src="' +
          item.image +
          '" alt="' +
          (item.title || '').replace(/"/g, '&quot;') +
          '" width="131" height="131" loading="lazy" class="et-bundle-hero__slot-image">';
      });

      renderPreviewSlider();
    }

    function syncItemFromRow(blockId) {
      var row = getRow(blockId);
      var product = getSelectedProduct(blockId);
      var variant = product && row ? resolveVariant(product, row) : null;

      if (!product || !variant || !row) {
        return false;
      }

      var qtyEl = row.querySelector('[data-bundle-qty-value]');
      var quantity = parseInt(qtyEl?.textContent || '1', 10) || 1;
      var image =
        variant.featured_image || product.featured_image || row.querySelector('[data-bundle-product-thumb]')?.dataset.placeholder || defaultImageSrc;

      state.items[blockId] = {
        productId: product.id,
        variantId: variant.id,
        id: variant.id,
        title: product.title + ' — ' + variant.title,
        image: image,
        price: Number(variant.price) || 0,
        compareAtPrice: Number(variant.compare_at_price || variant.price) || 0,
        quantity: quantity
      };
      state.editingBlockId = null;
      showRowState(blockId, 'filled');
      updateQtyControls(blockId);
      return true;
    }

    function setBuyButtonState(itemCount) {
      if (!buyButton) {
        return;
      }

      if (itemCount > 0) {
        buyButton.disabled = false;
        buyButton.removeAttribute('disabled');
      } else {
        buyButton.disabled = true;
      }
    }

    function syncAllVisibleRows() {
      section.querySelectorAll('[data-category-row]').forEach(function (row) {
        var productRow = row.querySelector('[data-bundle-product-row]');

        if (productRow && !productRow.hidden) {
          syncItemFromRow(row.dataset.categoryRow);
        }
      });
    }

    function updateTotals() {
      syncAllVisibleRows();

      var items = Object.values(state.items);
      var productCount = Object.keys(state.items).length;
      var count = items.reduce(function (sum, item) {
        return sum + item.quantity;
      }, 0);
      var subtotal = items.reduce(function (sum, item) {
        return sum + item.price * item.quantity;
      }, 0);
      var compare = items.reduce(function (sum, item) {
        return sum + item.compareAtPrice * item.quantity;
      }, 0);
      var bundleDiscount = getBundleDiscountPercent(productCount, discountTiers);
      var discounted =
        bundleDiscount > 0 ? Math.round((subtotal * (100 - bundleDiscount)) / 100) : subtotal;
      var savings = Math.max(compare - discounted, 0);
      var effectivePercent = compare > 0 ? Math.round((savings / compare) * 100) : 0;
      var maxTier = 0;
      Object.keys(discountTiers).forEach(function (key) {
        var tierValue = parseFloat(discountTiers[key]) || 0;
        if (tierValue > maxTier) {
          maxTier = tierValue;
        }
      });
      var missingPercent = Math.max(0, maxTier - bundleDiscount);

      totalRows.forEach(function (rowEl) {
        var labelEl = rowEl.querySelector('[data-bundle-total-label]');
        var compareEl = rowEl.querySelector('[data-bundle-total-compare]');
        var priceEl = rowEl.querySelector('[data-bundle-total-price]');
        var saveEl = rowEl.querySelector('[data-bundle-total-save]');

        if (labelEl) {
          var template = labelEl.dataset.template || '';

          if (missingPercent <= 0 && template.indexOf('__MISSING__') !== -1 && labelEl.dataset.templateFallback) {
            template = labelEl.dataset.templateFallback;
          }

          labelEl.textContent = template
            .replace('__COUNT__', String(count))
            .replace('__PERCENT__', effectivePercent + '%')
            .replace('__MISSING__', String(missingPercent));
        }

        if (compareEl) {
          compareEl.textContent = formatMoney(compare);
          compareEl.hidden = compare <= discounted;
        }

        if (priceEl) {
          priceEl.textContent = formatMoney(discounted);
        }

        if (saveEl) {
          if (savings > 0) {
            saveEl.textContent = (saveEl.dataset.savePrefix || 'Save') + ' ' + formatMoney(savings);
            saveEl.hidden = false;
          } else {
            saveEl.hidden = true;
          }
        }

        rowEl.hidden = productCount === 0;
      });

      if (buyButton) {
        setBuyButtonState(count);
      }

      renderSlots();
    }

    function getCartRoot() {
      return window.Shopify?.routes?.root || '/';
    }

    function syncAllItemsFromRows() {
      Object.keys(state.items).forEach(function (blockId) {
        syncItemFromRow(blockId);
      });
    }

    function goToCheckout() {
      syncAllItemsFromRows();

      var items = Object.values(state.items).map(function (item) {
        return {
          id: item.id,
          quantity: item.quantity,
          properties: {
            _bundle_builder: 'true'
          }
        };
      });

      if (!items.length || !buyButton) {
        return;
      }

      var root = getCartRoot();
      buyButton.disabled = true;

      fetch(root + 'cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin'
      })
        .then(function () {
          return fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              throw new Error(data?.description || 'Cart add failed');
            });
          }

          return response.json();
        })
        .then(function () {
          window.location.assign(root + 'checkout');
        })
        .catch(function () {
          var permalink =
            root +
            'cart/' +
            items
              .map(function (item) {
                return item.id + ':' + item.quantity;
              })
              .join(',');

          window.location.assign(permalink + '?checkout');
        });
    }

    function setActiveTab(blockId) {
      state.activeBlockId = blockId;

      section.querySelectorAll('.et-bundle-hero__tab').forEach(function (tab) {
        var isActive = tab.dataset.blockId === blockId;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      section.querySelectorAll('[data-bundle-panel]').forEach(function (panel) {
        panel.classList.toggle('is-active', panel.dataset.bundlePanel === blockId);
      });
    }

    function openCategory(blockId) {
      if (state.items[blockId]) {
        return;
      }

      state.editingBlockId = blockId;
      showRowState(blockId, 'editing');
      renderProductRow(blockId);
      syncItemFromRow(blockId);
      updateTotals();
    }

    function preselectCategories() {
      if (heroRoot.dataset.bundlePreselect !== 'true') {
        return;
      }

      section.querySelectorAll('[data-category-row]').forEach(function (row) {
        var blockId = row.dataset.categoryRow;

        if (!state.items[blockId] && parseCatalog(section, blockId).length) {
          openCategory(blockId);
        }
      });
    }

    function initStickyBuy() {
      if (heroRoot.dataset.bundleStickyBuy !== 'true' || !buyButton) {
        return;
      }

      var sentinel = section.querySelector('[data-bundle-buy-sentinel]');

      if (!sentinel || typeof IntersectionObserver === 'undefined') {
        return;
      }

      var mobileQuery = window.matchMedia('(max-width: 999px)');

      function setFloating(floating) {
        buyButton.classList.toggle('is-floating', floating);
        sentinel.style.height = floating ? buyButton.offsetHeight + 'px' : '0px';
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          setFloating(mobileQuery.matches && !entry.isIntersecting);
        });
      });

      observer.observe(sentinel);

      var onQueryChange = function () {
        if (!mobileQuery.matches) {
          setFloating(false);
        }
      };

      if (typeof mobileQuery.addEventListener === 'function') {
        mobileQuery.addEventListener('change', onQueryChange);
      } else if (typeof mobileQuery.addListener === 'function') {
        mobileQuery.addListener(onQueryChange);
      }
    }

    section.querySelectorAll('.et-bundle-hero__tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        setActiveTab(tab.dataset.blockId);
      });
    });

    section.querySelectorAll('[data-bundle-add-placeholder]').forEach(function (button) {
      button.addEventListener('click', function () {
        openCategory(button.dataset.openCategory);
      });
    });

    section.addEventListener('change', function (event) {
      var productSelect = event.target.closest('[data-bundle-product-select]');
      var optionSelect = event.target.closest('[data-bundle-option]');

      if (productSelect) {
        var blockId = productSelect.closest('[data-category-row]')?.dataset.categoryRow;
        state.editingBlockId = blockId;
        renderProductRow(blockId);
        syncItemFromRow(blockId);
        updateTotals();
        return;
      }

      if (optionSelect) {
        var optionBlockId = optionSelect.closest('[data-category-row]')?.dataset.categoryRow;
        state.editingBlockId = optionBlockId;
        updateProductThumb(optionBlockId);
        syncItemFromRow(optionBlockId);
        updateTotals();
      }
    });

    section.addEventListener('click', function (event) {
      var minus = event.target.closest('[data-bundle-qty-minus]');
      var plus = event.target.closest('[data-bundle-qty-plus]');
      var remove = event.target.closest('[data-bundle-remove]');

      if (remove) {
        var removeBlockId = remove.dataset.bundleRemove;
        delete state.items[removeBlockId];
        state.editingBlockId = null;
        var removeRow = getRow(removeBlockId);
        var removeQty = removeRow?.querySelector('[data-bundle-qty-value]');
        var removeSelect = removeRow?.querySelector('[data-bundle-product-select]');
        if (removeQty) {
          removeQty.textContent = '1';
        }
        if (removeSelect && removeSelect.options.length) {
          removeSelect.selectedIndex = 0;
        }
        showRowState(removeBlockId, 'empty');
        updateTotals();
        return;
      }

      if (minus) {
        var minusBlockId = minus.dataset.bundleQtyMinus;
        var row = getRow(minusBlockId);
        var qtyEl = row?.querySelector('[data-bundle-qty-value]');
        var current = parseInt(qtyEl?.textContent || '1', 10) || 1;

        if (current > 1 && qtyEl) {
          qtyEl.textContent = String(current - 1);
          syncItemFromRow(minusBlockId);
          updateQtyControls(minusBlockId);
        }

        updateTotals();
        return;
      }

      if (plus) {
        var plusBlockId = plus.dataset.bundleQtyPlus;
        var plusRow = getRow(plusBlockId);
        var plusQtyEl = plusRow?.querySelector('[data-bundle-qty-value]');

        if (plusQtyEl) {
          plusQtyEl.textContent = String((parseInt(plusQtyEl.textContent || '1', 10) || 1) + 1);
          syncItemFromRow(plusBlockId);
          updateQtyControls(plusBlockId);
          updateTotals();
        }
      }
    });

    section.querySelectorAll('.et-bundle-hero__accordion-toggle').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var accordion = toggle.closest('.et-bundle-hero__accordion');
        var isOpen = accordion.classList.contains('is-open');

        section.querySelectorAll('.et-bundle-hero__accordion.is-open').forEach(function (openAccordion) {
          openAccordion.classList.remove('is-open');
          openAccordion.querySelector('.et-bundle-hero__accordion-toggle')?.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          accordion.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });

    if (buyButton) {
      buyButton.addEventListener('click', goToCheckout);
    }

    section.querySelectorAll('[data-category-row]').forEach(function (row) {
      var blockId = row.dataset.categoryRow;
      renderProductRow(blockId);
      updateQtyControls(blockId);
    });

    refreshRowStates();

    initOfferTimer(section);
    preselectCategories();
    initStickyBuy();
    updateTotals();
  }

  function initAll() {
    document.querySelectorAll('.et-bundle-hero-section').forEach(function (section) {
      initHero(section);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.classList.contains('et-bundle-hero-section')) {
      event.target.dataset.initialized = 'false';
      initHero(event.target);
    }
  });
})();
